export const siteUrl = 'https://a2soft.ru';

export interface SeoPage {
  path: string;
  title: string;
  description: string;
  keywords?: string;
  index: boolean;
}

export const pages: SeoPage[] = [
  {
    path: '/',
    title: 'А2Софт — Решения на базе ИИ, разработка, интеграции',
    description: 'Внедряем ИИ для сокращения ручной работы и оптимизации процессов. '
      + 'Разрабатываем веб-сервисы, мобильные приложения, CRM и интеграции под задачи вашей команды и бизнеса.',
    keywords: [
      'А2Софт', 'A2Soft', 'искусственный интеллект', 'внедрение ИИ', 'ИИ для бизнеса',
      'автоматизация процессов', 'автоматизация бизнес-процессов', 'MCP', 'MCP-интеграции',
      'разработка', 'заказная разработка программного обеспечения', 'разработка ПО', 'веб-разработка',
      'разработка веб-сервисов', 'разработка мобильных приложений', 'iOS', 'Android',
      'разработка CRM', 'корпоративные системы', 'интеграция информационных систем', 'разработка API',
      'проектирование архитектуры ПО', 'frontend-разработка', 'backend-разработка',
      'аутсорс', 'аутсорсинг разработки', 'тех поддержка', 'сопровождение ПО', 'гарантия', 'fixed price',
      'C#', '.NET', 'ASP.NET Core', 'EF Core', 'React', 'JavaScript', 'TypeScript', 'Vue', 'Angular',
      'Flutter', 'React Native', 'Swift', 'Kotlin', 'MS Dynamics 365', 'BPMSoft', 'Creatio',
      'REST', 'SOAP', 'GraphQL', 'Kafka', 'RabbitMQ', 'IBM MQ', 'PostgreSQL', 'MSSQL', 'Oracle', 'Redis',
      'Docker', 'Kubernetes', 'CI/CD', 'Казань', 'Татарстан', 'Россия',
      'разработка ПО в Казани', 'ИТ-компания Татарстан', 'российская компания-разработчик',
    ].join(', '),
    index: true,
  },
  {
    path: '/privacy-policy',
    title: 'Политика обработки персональных данных — А2Софт',
    description: 'Политика обработки персональных данных ООО «А2СОФТ»',
    index: true,
  },
  {
    path: '/user-agreement',
    title: 'Информированное согласие пользователя сайта — А2Софт',
    description: 'Информированное согласие пользователя сайта',
    index: true,
  },
  {
    path: '/mobile_portfolio',
    title: 'Портфолио мобильной разработки — А2Софт',
    description: 'Портфолио мобильной разработки',
    index: false,
  },
];

export const getPage = (pathname: string): SeoPage => pages.find((page) => page.path === pathname) || pages[0];

export const getCanonical = (page: SeoPage): string | undefined => (
  page.index ? `${siteUrl}${page.path}` : undefined
);

export const organization = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  '@id': `${siteUrl}/#organization`,
  name: 'А2Софт',
  alternateName: 'A2Soft',
  url: `${siteUrl}/`,
  logo: `${siteUrl}/icon-512.png`,
  email: 'info@a2soft.ru',
  telephone: '+79950958700',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'улица Тукая, д. 23, 2 этаж',
    addressLocality: 'Казань',
    addressRegion: 'Республика Татарстан',
    postalCode: '420021',
    addressCountry: 'RU',
  },
};

export interface SeoMeta {
  name?: string;
  property?: string;
  content: string;
}

export const getMeta = (page: SeoPage): SeoMeta[] => [
  { name: 'description', content: page.description },
  ...(page.keywords ? [{ name: 'keywords', content: page.keywords }] : []),
  { name: 'robots', content: page.index ? 'index, follow, max-image-preview:large' : 'noindex, follow' },
  { property: 'og:type', content: 'website' },
  { property: 'og:locale', content: 'ru_RU' },
  { property: 'og:site_name', content: 'A2Soft' },
  { property: 'og:title', content: page.title },
  { property: 'og:description', content: page.description },
  ...(page.index ? [{ property: 'og:url', content: `${siteUrl}${page.path}` }] : []),
  { property: 'og:image', content: `${siteUrl}/icon-512.png` },
  { property: 'og:image:type', content: 'image/png' },
  { property: 'og:image:width', content: '512' },
  { property: 'og:image:height', content: '512' },
  { property: 'og:image:alt', content: 'A2Soft' },
  { name: 'twitter:card', content: 'summary' },
  { name: 'twitter:title', content: page.title },
  { name: 'twitter:description', content: page.description },
  { name: 'twitter:image', content: `${siteUrl}/icon-512.png` },
  { name: 'twitter:image:alt', content: 'A2Soft' },
];
